import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=2e441b48&"
import script from "./Editable.vue?vue&type=script&lang=js&"
export * from "./Editable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports